import { Column } from "react-table";
import { TableCustomHeader } from "../../component/table/components/TableCustomHeader";
import { TableCustomCell } from "../../component/table/components/TableCustomCell";
import { IService } from "../models/ServiceModels";

export const COLUMNS: ReadonlyArray<Column<IService>> = [
  {
    Header: (props) => (
      <TableCustomHeader<IService>
        tableProps={props}
        title="STT"
        className="text-center text-light spaces W-40"
      />
    ),
    id: "stt",
    Cell: ({ ...props }) => (
      <TableCustomCell
        className="text-center "
        data={props.data[props.row.index].stt}
      />
    ),
  },
  {
    Header: (props) => (
      <TableCustomHeader<any>
        tableProps={props}
        title="Mã dịch vụ"
        className="text-center text-light spaces min-w-50"
      />
    ),
    id: "code",
    Cell: ({ ...props }) => (
      <TableCustomCell
        className="text-center"
        data={props.data[props.row.index].code}
      />
    ),
  },
  {
    Header: (props) => (
      <TableCustomHeader<any>
        tableProps={props}
        title="Tên dịch vụ"
        className="text-center text-white align-middle bg-pri spaces min-w-100"
      />
    ),
    id: "name",
    Cell: ({ ...props }) => (
      <TableCustomCell
        className="s-2"
        data={props.data[props.row.index].name}
      />
    ),
  },
  {
    Header: (props) => (
      <TableCustomHeader<any>
        tableProps={props}
        title="Mô tả"
        className="text-center text-white align-middle bg-pri spaces min-w-100"
      />
    ),
    id: "contentType",
    Cell: ({ ...props }) => (
      <TableCustomCell
        className="text-center"
        data={props.data[props.row.index].description}
      />
    ),
  },
];
